import { render, staticRenderFns } from "./CompetitionsMapMarker.vue?vue&type=template&id=7a3f255a&"
import script from "./CompetitionsMapMarker.vue?vue&type=script&lang=js&"
export * from "./CompetitionsMapMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports